import { CountryWithSubdivisionField } from '@/features/SchemaForm/fields/CountryWithSubdivisionField';
import { PasswordField } from '@/features/SchemaForm/fields/PasswordField';
import { TextField } from '@/features/SchemaForm/fields/TextField';
import { TypedMultiInput } from '@/features/SchemaForm/fields/TypedMultiInput';
import { fieldContext, formContext } from '@/lib/form-context';
import { createFormHook } from '@tanstack/react-form';

export * from '@/lib/form-context';

export const { useAppForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    TypedMultiInput,
    CountryWithSubdivisionField,
    PasswordField,
  },
  formComponents: {},
});
